// JWT token management utilities
// Token is kept in-memory (not localStorage) for security.
// The httpOnly cookie set by the backend on login is the persistent auth mechanism.
// The in-memory token is used for mobile/API compatibility only.

const USER_KEY = 'dadbucks_user';

// In-memory token — never persisted to localStorage
let _inMemoryToken = null;

export const saveToken = (token) => {
    _inMemoryToken = token;
};

export const getToken = () => {
    return _inMemoryToken;
};

export const removeToken = () => {
    _inMemoryToken = null;
};

export const saveUser = (userData) => {
    // User profile data is safe to persist (no secrets)
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
};

export const getUser = () => {
    const userData = localStorage.getItem(USER_KEY);
    return userData ? JSON.parse(userData) : null;
};

export const removeUser = () => {
    localStorage.removeItem(USER_KEY);
    // Clean up any legacy token storage
    localStorage.removeItem('dadbucks_token');
};

export const isAuthenticated = () => {
    // Check in-memory token OR assume cookie-based auth may be active
    return !!getToken() || !!getUser();
};

// Add Authorization header to axios requests
export const getAuthHeaders = () => {
    const token = getToken();
    if (token) {
        return {
            'Authorization': `Bearer ${token}`
        };
    }
    // If no in-memory token, the httpOnly cookie will be sent automatically
    return {};
};
